import React, { memo } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { View, StyleSheet } from 'react-native';

import { Text, TextInput } from '../core-ui';
import { spacing } from '../constants/theme';

type Props = {
  'data-testid': string;
  title: string;
  from: string;
  until: string;
  setFrom: (value: string) => void;
  setUntil: (value: string) => void;
};

const SearchByDateRange = memo((props: Props) => {
  let { title, from, until, setFrom, setUntil } = props;
  return (
    <View style={[styles.flex, styles.row, styles.root]}>
      <View style={[styles.flex, styles.row]}>
        <SearchIcon color="inherit" fontSize="default" />
        <Text style={[styles.flex, styles.label]}>{title}</Text>
      </View>
      <View style={[styles.flex, styles.row]}>
        <TextInput
          data-testid={`${props['data-testid']}-from`}
          type="number"
          value={from?.toString()}
          onChangeText={setFrom}
          placeholder="0000"
          containerStyle={styles.flex}
        />
        <Text style={styles.to}>{t(['hingga', 'to'])}</Text>
        <TextInput
          data-testid={`${props['data-testid']}-until`}
          type="number"
          value={until?.toString()}
          onChangeText={setUntil}
          placeholder="0000"
          containerStyle={styles.flex}
        />
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  root: { height: 36, paddingHorizontal: spacing.xsmall },
  flex: { flex: 1 },
  row: { flexDirection: 'row', alignItems: 'center' },
  label: { paddingLeft: spacing.small },
  to: { paddingHorizontal: spacing.xsmall },
});

export default SearchByDateRange;
